import { ImageConvertStatus } from 'shared/domain/imageConvertStatus/imageConvertStatus';
import { EXTENSIONS } from 'shared/constants/EXTENSIONS';

export function getConvertableStatus(
  extension: string
): ImageConvertStatus {
  return extension?.toLowerCase() === EXTENSIONS.PDF
    ? ImageConvertStatus.PENDING
    : ImageConvertStatus.UNCONVERTABLE_EXTENSION;
}
